import Navbar from "@/components/feature/Navbar";
import Hero from "./components/Hero";
import Treatments from "./components/Treatments";
import Philosophy from "./components/Philosophy";
import Founders from "./components/Founders";
import Join from "./components/Join";
import Footer from "@/components/feature/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#f4f8f5] text-brand-900">
      <Navbar />
      <Hero />
      <Treatments />
      <Philosophy />
      <Founders />
      <Join />
      <Footer />
    </div>
  );
}